import React from 'react'
import { Chip, FormControlLabel, Radio } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  formControlLabel: {
    '& .MuiChip-root': {
      width: '118px',
      height: '32px',
    },

    '& .MuiIconButton-root': {
      display: 'none',
    },
  },
}))

const RadioChipOption = props => {
  const { checked, content, ...rest } = props
  const classes = useStyles({ checked })
  return (
    <FormControlLabel
      {...rest}
      className={classes.formControlLabel}
      label={<Chip label={content} color={checked ? 'primary' : 'default'} clickable />}
      control={<Radio checked={checked} color="primary" />}
    />
  )
}

export default RadioChipOption
